import React from 'react';
import { Box, Card, CardContent } from '@mui/material';
import { Engineering, BuildCircleOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { SvgIconComponent } from '@mui/icons-material';
import ReportsDirectoryHeader from '../components/sections/reportsDirectory/ReportsDirectoryHeader';
import ReportGroupCard from '../components/sections/reportsDirectory/ReportGroupCard';

interface ReportGroup {
  title: string;
  description: string;
  icon: SvgIconComponent;
  color: string;
  route: string;
}

const reportGroups: ReportGroup[] = [
  {
    title: 'Work Order Reports',
    description: 'Facility maintenance analytics and work order tracking',
    icon: Engineering,
    color: '#14b8a6',
    route: '/reports/work-orders'
  },
  {
    title: 'Preventive Maintenance',
    description: 'PM compliance, costs, and performance tracking across locations',
    icon: BuildCircleOutlined,
    color: '#8b5cf6',
    route: '/reports/pm'
  }
];

/**
 * ReportsDirectoryPage - Landing page displaying report categories as clickable cards
 */
const ReportsDirectoryPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc', py: 1.5, px: 2 }}>
      <Box display="flex" justifyContent="center">
        <Card
          sx={{
            maxWidth: 1200,
            width: '100%',
            borderRadius: 2,
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            border: '1px solid #e2e8f0',
            overflow: 'hidden'
          }}
        >
          <ReportsDirectoryHeader />
          <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  sm: 'repeat(2, 1fr)',
                  lg: 'repeat(3, 1fr)'
                },
                gap: 3
              }}
            >
              {reportGroups.map((group) => (
                <ReportGroupCard
                  key={group.route}
                  title={group.title}
                  description={group.description}
                  icon={group.icon}
                  color={group.color}
                  onClick={() => navigate(group.route)}
                />
              ))}
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default ReportsDirectoryPage;
